// extracted by mini-css-extract-plugin
export default {"title":"cookieBannerPanelTitle_title"};